


















import KeyNamePair from '@/data/KeyNamePair'
import { defineComponent, PropType, ref } from '@vue/composition-api';
export default defineComponent({
  props: {
    selectValues: {
      type: Array as PropType<Array<KeyNamePair>>,
      required: true
    },
    defaultKeyValue: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: false
    }
  },
  emits: {
    select: (value: string) => value !== undefined
  },
  setup(props, context) {

    const selectElem = ref<HTMLSelectElement|null>(null);
    
    const getValue = (value: string) => {
      return value;
    };
    const onChange = () => {
      if(!selectElem.value) return;
      context.emit('select', selectElem.value.value);
    };
    return {
      getValue,
      selectElem,
      onChange
    };
  }
});
